import React, { PropsWithChildren } from 'react';
import {
    FormHeader,
    FormLabel,
    ChoiceGroup,
    FormControl,
    FormTooltip,
    FormSubtitle,
    FormHelperText,
    FormElementController,
} from '@fiverr-private/forms';
import { Text } from '@fiverr-private/typography';
import { Container } from '@fiverr-private/layout_components';

interface FormChoiceGroupProps {
    name: string;
    label: string;
    subtitle?: string;
    tooltip?: string;
    disabled?: boolean;
}

export const FormChoiceGroup = <T,>({
    name,
    children,
    label,
    subtitle,
    tooltip,
    disabled = false,
}: PropsWithChildren<FormChoiceGroupProps>) => (
    <FormControl name={name}>
        {(label || subtitle) && (
            <FormHeader>
                {label && (
                    <FormLabel htmlFor={name}>
                        <Text fontWeight="semibold" size="b_md">
                            {label}
                        </Text>
                    </FormLabel>
                )}
                {tooltip && <FormTooltip content={tooltip} />}
                {subtitle && <FormSubtitle>{subtitle}</FormSubtitle>}
            </FormHeader>
        )}
        <FormElementController
            render={({ field: { onChange, onBlur, value } }) => (
                <Container marginTop="2" {...(disabled && { pointerEvents: 'none' })}>
                    <ChoiceGroup<T>
                        size="xl"
                        direction="column"
                        multiple={false}
                        value={value}
                        onBlur={onBlur}
                        onChange={(newValue: T | T[] | null) => onChange(newValue || value)}
                    >
                        {children}
                    </ChoiceGroup>
                </Container>
            )}
        />
        <FormHelperText />
    </FormControl>
);
